export function concatAction({ status, userId, others }) {
  // console.log('--------others------->', others);
  let str;
  if (status) {
    // str = "userId-" + userId ;
    str = status + "," + userId;
  }

  for (const property in others) {
    // str += `, ${property} - ${others[property]}`;
    str += `,${others[property]}`;
  }
  return str;
}
export function concatSubAction({ title, others }) {
  // console.log('--------others------->', others);
  let str;

  // str = "userId-" + userId ;
  str = title;

  for (const property in others) {
    // str += `, ${property} - ${others[property]}`;
    str += `,${others[property]}`;
  }
  return str;
}
